import { useParamsSearch } from '@anytag/shared-hooks';
import { AdCampaignReportSearchSchemaType } from '../schemaTypes';

export const useAdCampaignReportFilter = () => useParamsSearch<AdCampaignReportSearchSchemaType>();
